import axios from "axios"

export const API_BASE_URL= "https://winter.pt2000.com.vn/"
//export const API_BASE_URL= "http://localhost:8000/"
export const IMAGES_URL = "https://winter.pt2000.com.vn/hinhanh/"

export const api=axios.create({
    baseURL:API_BASE_URL,
    headers:{
        'Content-Type':'application/json'
    }
})
